'use strict'

module.exports = {
  DEFAULT_URL : 'https://agentsremotely.com/media/default-hold-music.mp3',
  URL_PREFIX : 'https://agentsremotely.com/media/',
};
